<template>
    <div class="home">
        <div>
            <div class="welcome">
                <img src="../assets/login/logo2.png">
                <p>欢迎使用南阳经开高标准数字园区综合服务平台管理后台</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted(){
    }
}
</script>

<style lang="scss" scoped>
.home{
	position: relative;
	width: 100%;
	height: calc(100% - 34px);
  background: transparent !important;
    &>div{
        width: 100%;
        height: 100%;
       
    }
}
.welcome{
    // position: absolute;
    // top: 40%;
    // left: 50%;
    // transform: translate(-50%,-50%);
    // text-align: center;
	width: 1127px;
	height: 534px;
	// position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
	background: url(../assets/login/home-top.png) no-repeat;
	background-size: 100% 100%;
    img{
        width: 495px;
		display: block;
		margin: auto;
		margin-top: 129px;
    }
    p{
        // font-size:33px;
        // font-weight:bold;
        // color:rgba(81,81,81,1);
        // margin-top: 20px;
        font-size:36px;
        font-family:Microsoft YaHei;
        font-weight:400;
        // line-height:36px;
        color:rgba(51,51,51,1);
        letter-spacing:8px;
        margin-top:50px;
        text-align: center;
    }
}
</style>